import { combineReducers } from "@reduxjs/toolkit";
import adminOrganization from "./admin-organization";
import organizationStaff from "./organization-staff";
import permissions from "./permissions";
import adminUsers from "./admin-users";
import portalUsers from "./portal-users";
import roles from "./roles";
import stores from "./stores";
import achievements from "./achievements";
import promotions from "./promotions";
import settings from "./settings";
import organizationAchievements from "./organization-achievements";
import organization from "./organization";
import punchcards from "./punchcards";
import customers from "./customers";
import rewards from "./rewards";
import integrationTemplates from "./integration-templates";
import integrations from "./integrations";
import geofences from "./geofences";
import analytics from "./analytics";
import appStoreMonitor from "./app-store-monitor";
import appStoreIssues from "./app-store-issues";
import resourceLinks from "./resource-links";
import appleSetup from "./apple-setup";
import trainingVideo from "./training-video";
import reports from "./reports";

const rootReducer = combineReducers({
    adminOrganization: adminOrganization,
    organizationStaff: organizationStaff,
    permissions: permissions,
    adminUsers: adminUsers,
    portalUsers: portalUsers,
    roles: roles,
    stores: stores,
    achievements: achievements,
    organizationAchievements: organizationAchievements,
    promotions: promotions,
    settings: settings,
    organization: organization,
    punchcards: punchcards,
    customers: customers,
    rewards: rewards,
    integrationTemplates: integrationTemplates,
    integrations: integrations,
    geofences: geofences,
    analytics: analytics,
    appStoreMonitor: appStoreMonitor,
    appStoreIssues: appStoreIssues,
    resourceLinks: resourceLinks,
    appleSetup: appleSetup,
    trainingVideo: trainingVideo,
    reports: reports,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
